module.exports = __webpack_public_path__ + "6f8f3ef5f0e08c12a726e3a3a5670431.png";